import React, { useEffect, useMemo, useState } from 'react';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useBankKurbanUIContext } from '../BankKurbanUIContext';
import { initialFilter, statusList } from '../BankKurbanUIHelpers'
import { getFundtypeAll } from "../../../../MasterData/_redux/fund_type/fundtypeCrud";
import { getBankAll } from "../../../../MasterData/_redux/bank/bankCrud";
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';


const prepareFilter = (queryParams, values) => {
    const {
        type,
        bank,
        channel_name,
        status,
        start_date,
        end_date
    } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    //add to Object filter
    filter.bank = bank ?? ""
    filter.channel_name = channel_name ?? ""
    filter.status = status ?? ""
    filter.start_date = start_date ?? ""
    filter.end_date = end_date ?? ""
    filter.type = "BANK_KURBAN"


    newQueryParams.filter = filter;
    return newQueryParams;
};

export const BankKurbanFilter = () => {

    const bankKurbanUIContext = useBankKurbanUIContext();
    const bankKurbanUIProps = useMemo(() => {
        return {
            setQueryParams: bankKurbanUIContext.setQueryParams,
            queryParams: bankKurbanUIContext.queryParams,
            filterType: bankKurbanUIContext.filterType,
            statusList: bankKurbanUIContext.statusList
        };
    }, [bankKurbanUIContext]);


    // USE STATE
    const [bankList, setBankList] = useState([]);
    const [kodeRek, setKodeRek] = useState([]);
    const [typeDona, setTypeDona] = useState([]);
    const [showRekeningField, setShowRekeningField] = useState(false)
    const [onFocused, setOnFocused] = useState(null)
    const [tanggal, setTanggal] = useState(
        {
            start_date: null,
            end_date: null,
        }
    )


    const showRekening = (event, setFieldValue, handleSubmit) => {
        setFieldValue('bank', event.target.value)
        const value = event.target.value;
        if (value === '') {
            setKodeRek([]);
            setFieldValue('channel_name', '')
            handleSubmit(event)
            setShowRekeningField(false)
        } else {
            setShowRekeningField(true)
            let obj = bankList.find(object => object.uuid === value);
            setKodeRek(obj.channel);
        }
    };

    const applyFilter = (values) => {
        const newQueryParams = prepareFilter(bankKurbanUIProps.queryParams, values);
        if (!isEqual(newQueryParams, bankKurbanUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            bankKurbanUIProps.setQueryParams(newQueryParams);
        }
    };

    const fetchType = async () => {
        const result = await getFundtypeAll();
        let nonKurbanResult = result.data.data.filter(filter => filter !== 'KURBAN')
        setTypeDona(nonKurbanResult);
    };

    const fetchBank = async () => {
        const result = await getBankAll();
        setBankList(result.data.data);
    };

    useEffect(() => {
        fetchType();
        fetchBank();
        // eslint-disable-next-line
    }, []);

    return (
        <Formik initialValues={initialFilter.filter} onSubmit={(values) => {
            applyFilter(values);
        }}
        >
            {({ values, handleSubmit, handleBlur, setFieldValue }) => (
                <form onSubmit={handleSubmit} className="form form-label-right">

                    {/*ROW 1 BY DONATUR*/}
                    <div className="form-group row">


                        {/*ROW 2*/}
                        {/* Channel UUID */}
                        <div className="col-lg-4 mb-3">
                            <select name="status"
                                className="form-control"
                                onChange={e => {
                                    handleSubmit(e)
                                    setFieldValue('status', e.target.value)
                                }}
                            >
                                <option value="">ALL</option>
                                {
                                    bankKurbanUIProps.statusList.map(row => {
                                        return <option value={row.value}>{row.name}</option>
                                    })
                                }
                            </select>
                            <small className="form-text text-muted">
                                <b>Cari</b> Status Import
                            </small>
                        </div>

                        <div className="col-lg-4 mb-3">
                            <select
                                className="form-control"
                                name="bank" onChange={(e) => {
                                    showRekening(e, setFieldValue, handleSubmit)
                                    setFieldValue('bank', e.target.value)
                                    handleSubmit(e)

                                }}>
                                <option value="">ALL</option>
                                {bankList.map(item =>
                                    <option key={item.uuid} value={item.uuid}>{item.name}</option>,
                                )}
                            </select>
                            <small className="form-text text-muted">
                                <b>Cari</b> Bank
                            </small>
                        </div>

                        {/* Channel UUID */}
                        {showRekeningField && (
                            <div className="col-lg-4 mb-3">
                                {/* <select name="channel_name"
                                    className="form-control"
                                    onChange={e => {
                                        handleSubmit(e)
                                        setFieldValue('channel_name', e.target.value)
                                    }}>
                                    <option value="">--ALL--</option>
                                    {
                                        kodeRek.map(row =>
                                            <option key={row.uuid} value={row.name}>{row.name}</option>,
                                        )
                                    }
                                </select> */}
                                <Autocomplete
                                    name="chName"
                                    options={kodeRek}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(e, value) => {
                                        if (value) {
                                            handleSubmit(e)
                                            setFieldValue('channel_name', value.name)

                                        } else {
                                            handleSubmit(e)
                                            setFieldValue('channel_name', "")
                                        }
                                    }}
                                    loading={kodeRek.length === 0 ? true : false}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Cari Nomor Rekening"
                                            variant="outlined"
                                            disableClearable
                                            size="small"

                                        />
                                    )}
                                />
                                <small className="form-text text-muted">
                                    <b>Cari</b> Nomor Rekening
                                </small>
                            </div>
                        )}
                        <div className="col-lg-4 mb-3">
                            <DateRangePicker
                                small={true}
                                startDate={tanggal.start_date}
                                endDate={tanggal.end_date}
                                onDatesChange={({ startDate, endDate }) => {
                                    setTanggal({
                                        start_date: startDate,
                                        end_date: endDate
                                    })
                                    setFieldValue('start_date', startDate)
                                    setFieldValue('end_date', endDate)
                                    handleSubmit(startDate)
                                    handleSubmit(endDate)
                                }}
                                focusedInput={onFocused}
                                onFocusChange={focusedInput => setOnFocused(focusedInput)}
                                numberOfMonths={1}
                                isOutsideRange={() => false}
                                showClearDates={true}
                                startDateId="start_date"
                                endDateId="end_date"
                                hideKeyboardShortcutsPanel={true}
                            />
                            <small className="form-text text-muted">
                                Cari berdasarkan <b>Tanggal Import</b>
                            </small>
                        </div>
                    </div>

                    <div className="form-group row">


                    </div>

                </form>
            )}
        </Formik>

    );

};

